import * as R from 'ramda';
import { reducerWrapper } from '../support/utils';

import { SCHEDULE_GET, SCHEDULE_LIST, SCHEDULE_CREATE, SCHEDULE_UPDATE } from '../actions/ScheduleActions';
import { ScheduleJourneyService } from '../services/ScheduleJourneyService/ScheduleJourneyService';

export const INIT_STATE = {
  loading: false,
  error: null,
  data: null,
  scheduleList: null,
};

function Handler(state, action) {
  switch (action.type) {
    case SCHEDULE_UPDATE.response:
    case SCHEDULE_CREATE.response: {
      let sch = action.data;
      if (sch.recurrence) {
        const { next_start, next_stop } = ScheduleJourneyService.getNextStartStop(sch);

        sch = {
          ...sch,
          recurrence: {
            ...sch.recurrence,
            next_start,
            next_stop,
          },
        };
      }

      return Object.assign({}, state, {
        loading: false,
        scheduleList: Object.assign({}, state.scheduleList, {
          [action.data.id]: sch,
        }),
      });
    }
    case SCHEDULE_GET.response:
      return R.merge(state, {
        loading: false,
        schedule: action.data,
      });
    case SCHEDULE_LIST.response: {
      const scheduleListArr = action.data.map((sch) => {
        if (sch.recurrence) {
          const { next_start, next_stop } = ScheduleJourneyService.getNextStartStop(sch);

          return {
            ...sch,
            recurrence: {
              ...sch.recurrence,
              next_start,
              next_stop,
            },
          };
        }
        return sch;
      });

      const scheduleListObject = scheduleListArr.reduce((acc, sch) => ({ ...acc, [sch.id]: sch }), {});
      return R.merge(state, {
        loading: false,
        scheduleList: scheduleListObject,
      });
    }
    default:
      return state;
  }
}

const Schedule = reducerWrapper(INIT_STATE, Handler, {
  request: [SCHEDULE_GET, SCHEDULE_LIST, SCHEDULE_CREATE, SCHEDULE_UPDATE],
  error: [SCHEDULE_GET, SCHEDULE_LIST, SCHEDULE_CREATE, SCHEDULE_UPDATE],
  resetOn: ['APP_CHANGE'],
});

export default Schedule;
